import { lazyLoad } from 'app/utils/loadable';

export const Profile = lazyLoad(
  () => import('./profile'),
  (module) => module.Profile
);
